export const palette={
	success:"#081",
	danger:"#F11",
	warning:"#EB0"
}